<template>
  <div
    class="alert alert-info text-center"
    v-if="user && handler && user.id != handler.id"
  >
    This claim is assigned to {{ handler.full_name }}
  </div>
</template>
<script>
export default {
  computed: {
    handler() {
      return this.$store.getters['Incident/handler'];
    },

    user() {
      return this.$store.getters.user;
    }
  }
};
</script>
